/**
 * Menu item configurations for desktop and mobile
 */

export default [
  {
    label: 'Cases',
    tooltip: 'Search Incidents',
    link: '/Cases',
    icon: 'clipboard',
  },
  {
    label: 'Events',
    tooltip: 'Events',
    link: '/Events',
    icon: 'calendar-week',
  },
];
